// extracted by mini-css-extract-plugin
export default {"checkBoxContainer":"CustomCheckBox_checkBoxContainer__CdhnK","checkboxInput":"CustomCheckBox_checkboxInput__EK7iv"};